import { push } from 'react-router-redux';

import addCookieWithConsent from '../pattern_utilities/addCookieWithConsent';

export * from './user/a.u.POST.register.js';
export * from './user/a.u.POST.login.js';
export * from './user/a.u.POST.login.mfa.js';
export * from './user/a.u.POST.login.send-email.js';
export * from './user/a.u.POST.recover-account.js';
export * from './user/a.u.POST.confirm-email.js';
export * from './user/a.u.POST.reset-password.js';
export * from './user/a.u.POST.mfa.email.setup.js';
export * from './user/a.u.POST.mfa.email.enable.js';
export * from './user/a.u.POST.mfa.app.setup.js';
export * from './user/a.u.POST.mfa.app.enable.js';

// export * from './user/a.u.POST.upgrade-to-pro.js';
// export * from './user/a.u.POST.payment-method.js';
// export * from './user/a.u.POST.set-default-payment-method.js';

export * from './user/a.u.PUT.change-password.js';
export * from './user/a.u.PUT.change-email.js';
export * from './user/a.u.PUT.resend-email.js';
export * from './user/a.u.PUT.change-user-info.js';
export * from './user/a.u.PUT.change-default-settings.js';
export * from './user/a.u.PUT.change-default-workspace.js';

export * from './user/a.u.DELETE.me.js';
// export * from './user/a.u.DELETE.me-enterprise.js';
// export * from './user/a.u.DELETE.payment-method.js';
// export * from './user/a.u.DELETE.cancel-pro.js';
export * from './user/a.u.DELETE.mfa.email.js';
export * from './user/a.u.DELETE.mfa.app.js';


export * from './user/a.u.POST.create-portal-session.js';
export * from './user/a.u.POST.create-checkout-session.js';

export * from './user/a.u.GET.account-info.js';
export * from './user/a.u.GET.my-pending-invites.js';
// export * from './user/a.u.GET.billing-status.js';
// export * from './user/a.u.GET.invoice.js';
// export * from './user/a.u.GET.past-invoices.js';
// export * from './user/a.u.GET.payment-methods.js';


export const logOut = error => ({
  type: 'LOGOUT',
  error
})

export const saveToken = token => dispatch =>{
  addCookieWithConsent(process.env.REACT_APP_COOKIE_AUTH, token, dispatch, 7, true);

  dispatch(thenSaveToken(token));
}

const thenSaveToken = data => ({
  type: 'SAVE_TOKEN',
  data
})

export const loadToken = data => ({
  type: 'LOAD_TOKEN',
  data
})


export const saveMFAToken = token => dispatch =>{
  addCookieWithConsent(process.env.REACT_APP_COOKIE_MFA_AUTH, token, dispatch, new Date(new Date().getTime() + 10 * 60 * 1000), true);

  dispatch(thenSaveMFAToken(token));
}

const thenSaveMFAToken = data => ({
  type: 'SAVE_MFA_TOKEN',
  data
})



// WEBPACK FOOTER //
// ./src/actions/actions.user.js